var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.894,
    height: 12.942,
    viewBox: "0 0 20.894 12.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36937",
    "data-name": "Group 36937",
    transform: "translate(-419.699 -315.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_group_737657",
    transform: "translate(419.699 315.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35463",
    "data-name": "Group 35463",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63871",
    "data-name": "Path 63871",
    d: "M9.333,36.8a1.733,1.733,0,1,0,1.733,1.733A1.723,1.723,0,0,0,9.333,36.8Z",
    transform: "translate(-6.379 -32.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63872",
    "data-name": "Path 63872",
    d: "M6.049,61.273l-.079-.059V59.5a4.743,4.743,0,0,1,.355-1.832,2.892,2.892,0,0,0-1.97-.768A2.989,2.989,0,0,0,1.4,59.855v.926a5.988,5.988,0,0,0,2.935.67A7.762,7.762,0,0,0,6.049,61.273Z",
    transform: "translate(-1.4 -49.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63873",
    "data-name": "Path 63873",
    d: "M76.533,40.267A1.733,1.733,0,1,0,74.8,38.533,1.749,1.749,0,0,0,76.533,40.267Z",
    transform: "translate(-58.574 -32.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63874",
    "data-name": "Path 63874",
    d: "M73.955,61.375l-.079.059a7.542,7.542,0,0,0,1.694.2,5.988,5.988,0,0,0,2.935-.67v-.926a2.928,2.928,0,0,0-4.9-2.167,5.139,5.139,0,0,1,.355,1.832Z",
    transform: "translate(-57.611 -49.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63875",
    "data-name": "Path 63875",
    d: "M36.3,19.9A2.7,2.7,0,1,0,39,17.2,2.7,2.7,0,0,0,36.3,19.9Z",
    transform: "translate(-28.541 -17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63876",
    "data-name": "Path 63876",
    d: "M36.122,53.249V51.811a4.511,4.511,0,1,0-9.022,0v1.438a8.775,8.775,0,0,0,4.511,1.064A8.975,8.975,0,0,0,36.122,53.249Z",
    transform: "translate(-21.152 -41.371)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPerformance);
export default __webpack_public_path__ + "static/media/student-performance.37fe2712735ceca60594969485e8f174.svg";
export { ForwardRef as ReactComponent };